/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, imageTypes, replacePXinStringWithEM } from 'utils/styles';



// ===================== ANIMATION : TOP : PROGRESS BAR / SHARE SET ICONS ===================== //
const aniFrameCountdownBarInitial = {
    // ~~~~~~~~~~~~~~~~~~~~~ INITIAL STATE ~~~~~~~~~~~~~~~~~~~~~ //
    '& .progressbar.type-frame': {

    }
};



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export { aniFrameCountdownBarInitial };